import { render, staticRenderFns } from "./VisitorDocumentsFormBlock.vue?vue&type=template&id=24634180&scoped=true&"
import script from "./VisitorDocumentsFormBlock.vue?vue&type=script&lang=js&"
export * from "./VisitorDocumentsFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./VisitorDocumentsFormBlock.vue?vue&type=style&index=0&id=24634180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24634180",
  null
  
)

export default component.exports